"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = _interopRequireDefault(require("./constants"));

var _StackingContext = _interopRequireDefault(require("./StackingContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Stack = function Stack(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return _react["default"].createElement(_StackingContext["default"].Consumer, null, function (previous) {
    var current = Math.max(previous, value);
    var next = current + 1;
    return _react["default"].createElement(_StackingContext["default"].Provider, {
      value: next
    }, children(current)); //foo 
  });
};

Stack.propTypes = {
  value: _propTypes["default"].number
};
Stack.defaultProps = {
  value: _constants["default"].DEFAULT
};
Stack.constants = _constants["default"];
var _default = Stack;
exports["default"] = _default;